import { useSearchParams } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { supabase } from "../supabase";
import { IndexTags } from "./utils";

export function TagSort() {

    useEffect(() => { // fetch all possible tags from supabase
        const retrievetags = async () => {
            const { error } = await supabase
            .from("Tags")
            .select("*")

            if (error) {
                console.error(error)
            }
        }

        retrievetags()
    }, [])

    const [searchParams, setSearchParams] = useSearchParams()

    const selectedTags = useMemo(() => {
        const getTags = () => {
            const raw = searchParams.get("tags")
            if (!raw) return []

            const origin = raw.split(",").filter(Boolean)
            if (origin.length === 0) return []

            return origin.map(w =>
                w
                    .split(" ")
                    .map(nw => nw.charAt(0).toUpperCase() + nw.slice(1))
                    .join(" ")
            )
        }
        return getTags()
    }, [searchParams])
        
    function removeTag(tag) {
        const newselected = selectedTags.filter(t => t !== tag);
        
        // Use functional update to preserve other search parameters
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev)
            
            if (newselected.length > 0) {
                newParams.set("tags", newselected.join(","));
            } else {
                newParams.delete("tags"); // clean up if no tags left
            }
            
            return newParams
        });
    }
        
    return (
        <div className="tagssection">
            <div className="fulltags">
                <div className="tagspace">
                    {
                        selectedTags.map((tag, i) => (
                            <Tag 
                                key={i} // Add key prop for React
                                info={tag} 
                                searchtag={false} 
                                sortTag={true}  
                                removeTag={removeTag}
                            />
                        ))
                    }
                    {/* New-tag input removed: tags are visual only here */}
                </div>
            </div>
        </div>
    )
}

export function Tag({info, sortTag=false, setTagSearch=null, searchtag, searchResults=null, selectedTags=null, removeTag=null, addTag=null, setColor=null, inline=false}) {
    
    const [alltags, setalltags] = useState([])

    useEffect(() => { // fetch all possible tags from supabase
        const retrievetags = async () => {
            const {data, error} = await supabase
            .from("Tags")
            .select("*")

            if (error) {
                console.error(error)
            } else {
                setalltags(data)
            }
        }

        retrievetags()
    }, [])
    
    const tagColor = useMemo(() => IndexTags(alltags), [alltags])
    const color = setColor || (tagColor[info] || "g")
    
    const [dropdown, setDropdown] = useState(false)

    const displayable = useMemo(() => {
        if (!searchResults || !selectedTags) return [];
        return searchResults.filter(tag => !selectedTags.includes(tag));
    }, [searchResults, selectedTags]);
    
    const [taginput, settaginput] = useState("")

    const handleTagClick = (tag, e) => {
        e.stopPropagation() // Prevent event bubbling
        addTag(tag)
        settaginput("")
        setTagSearch("")
    }

    return (
        <div className="tagsholder" 
            onClick={() => {
                if (sortTag) {
                    removeTag(info)
                }
            }}
            onFocus={() => {setDropdown(true)}}
            onBlur={(e) => {
                // Add slight delay to allow click events to register first
                setTimeout(() => setDropdown(false), 150)
            }}
        >
            <div className={`type1 ${color}`}>
                <div className={`dot ${color}`}>
                    <div className={`dotimg ${color}`}></div>
                    {searchtag ? (
                        <input
                            className="taginputtext"
                            placeholder={info}
                            value={taginput}
                            onChange={(e) => {
                                setTagSearch(e.target.value)
                                settaginput(e.target.value)
                            }}
                        />
                    ) : (
                        <div className="text">{info}</div>
                    )}
                </div>
            </div>
            {
                searchtag && dropdown && (
                    <div className={`tagsdropdown ${dropdown ? "opend" : "closedd"}`}>
                        <div className="tagscrollwrapper">
                            {
                                displayable.map((tag, i) => (
                                    <div 
                                        key={i} // Add key prop
                                        className="tagsscroll" 
                                        onMouseDown={(e) => handleTagClick(tag, e)} // Use onMouseDown instead of onClick
                                    >
                                        <div className={`resultdot ${tagColor[tag] || 'g'}`}></div>
                                        <div className="searchresult">{tag}</div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )
            }
        </div>
    )
}